// src/components/Footer.jsx
import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-elion-navy text-center text-white py-6 mt-12">
      <p className="text-xl font-bold">ELION</p>
      <p className="text-elion-gold mt-1">Eleve sua carreira</p>
    </footer>
  );
};

export default Footer;
